import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { Card } from 'antd';
import { PageLayout } from '../../components/PageLayout/PageLayout';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage = () => {
    const [markdown, setMarkdown] = useState('');

    useEffect(() => {
        fetch(require('./PRIVACY_POLICY.md'))
            .then(response => response.text())
            .then(text => setMarkdown(text))
            .catch(error => console.error('Error loading privacy policy:', error));
    }, []);

    return (
        <PageLayout fullWidth>
            <Card
                variant="outlined"
                className="markdown-container privacy-policy-card"
                style={{
                    border: '2px solid #7a7a7a',
                }}
            >
                <ReactMarkdown>{markdown}</ReactMarkdown>
            </Card>
        </PageLayout>
    );
}

export default PrivacyPolicyPage;